<div 
  class="notification-container"
  [class]="getTypeClass()"
  [@slideInOut]="isVisible ? 'in' : 'out'"
  (click)="closeNotification()">
  
  <!-- Icono -->
  <div class="notification-icon">
    <i [class]="getIconClass()"></i>
  </div>
  
  <!-- Contenido -->
  <div class="notification-content">
    <h4 class="notification-title">{{ notification.title }}</h4>
    <p class="notification-message">{{ notification.message }}</p>
  </div>
  
  <!-- Botón de cerrar -->
  <button 
    *ngIf="notification.showClose !== false"
    class="notification-close"
    (click)="closeNotification()"
    type="button">
    <i class="pi pi-times"></i>
  </button>
  
  <!-- Barra de progreso (si tiene duración) -->
  <div 
    *ngIf="notification.duration && notification.duration > 0"
    class="notification-progress">
    <div class="progress-bar" [style.width.%]="progressWidth"></div>
  </div>
</div>
